import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/recruitView";

const RECRUIT_VIEW = "recruit/RECRUIT_VIEW";
const RECRUIT_VIEW_PENDING = "recruit/RECRUIT_VIEW_PENDING";
const RECRUIT_VIEW_SUCCESS = "recruit/RECRUIT_VIEW_SUCCESS";

const FILE_DOWN = "recruit/FILE_DOWN";

export const recruitView = createPromiseThunk(RECRUIT_VIEW, api.recruitView);
export const fileDown = createPromiseThunk(FILE_DOWN, api.fileDown);

const initialState = {
  data: null,
  files: null
};

export default handleActions(
  {
    [RECRUIT_VIEW_PENDING]: state => ({ ...state, data: null }),
    [RECRUIT_VIEW_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data.studyData,
      files: payload.data.fileList
    })
  },
  initialState
);
